import { type FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import TrophyIcon from 'app/icons/trophy_plain.svg';
import { getMapRecapText } from 'app/components/MatchesRecap/utils';
import HourglassIcon from 'app/icons/hourglass.svg';

import style from './style.module.scss';

interface Props {
  scoreboardGame: MatchGame | undefined;
  matchStatus: EventStatus;
  hasLiveStats: boolean;
  size: 'small' | 'large';
  winnerInfo: OpponentBase | undefined;
  winnerSide: SideDota2 | null;
  videogameSlug: VideogameSlug;
}

const InterGameMessage: FC<Props> = ({
  hasLiveStats,
  scoreboardGame,
  matchStatus,
  size,
  winnerSide,
  winnerInfo,
  videogameSlug
}) => {
  const { t } = useTranslation();

  const interGameMessageClassNames = classNames(
    style.interGameMessage,
    style[size],
    winnerSide && style[winnerSide]
  );

  if (scoreboardGame && matchStatus === 'running') {
    if (scoreboardGame.status === 'running' && !hasLiveStats) {
      return (
        <div
          className={interGameMessageClassNames}
          key={`${scoreboardGame.id}-${scoreboardGame.status}`}
        >
          <div className={style.interGameMessageContent}>
            <HourglassIcon className={style.hourglassIcon} />
            <span>
              <strong className={style.strong}>
                {t(getMapRecapText(videogameSlug), { gameNumber: scoreboardGame.position })}
              </strong>{' '}
              {t('component_inbetween-game_will-start-soon')}
            </span>
          </div>
        </div>
      );
    }

    if (scoreboardGame.status === 'finished') {
      return (
        <div
          className={interGameMessageClassNames}
          key={`${scoreboardGame.id}-${scoreboardGame.status}`}
        >
          <div className={style.interGameMessageContent}>
            <TrophyIcon className={style.trophyIcon} />
            {winnerInfo ? (
              <span>
                <strong className={style.strong}>{winnerInfo.name}</strong>{' '}
                <span>{t('component_inbetween-game_victory')}</span>
              </span>
            ) : (
              <span>
                <strong className={style.strong}>
                  {t(getMapRecapText(videogameSlug), { gameNumber: scoreboardGame.position })}
                </strong>{' '}
                <span>{t('component_inbetween-game_over')}</span>
              </span>
            )}
            <span className={style.breakDivider}>
              <span />
            </span>
            <span>{t('component_inbetween-game_break')}</span>
          </div>
        </div>
      );
    }
  }

  return null;
};

InterGameMessage.displayName = 'InterGameMessage';

export default InterGameMessage;
